<template>
    <div class="flex xs12"> 
        <template v-for="(list, index) in data">
            <div :class="['input-wrapper', getIfFieldFocusClass(list.items)]" 
                :key="`intervention-cat${index}`">
                <div class="header">{{ list.category }}</div>
                <template v-for="(item, key) in list.items">
                    <laid-out-select-input
                        v-if="item.config.inputType == 's'"
                        :key="`intervention-item${index}-${key}`"
                        :options="item.config.options"
                        :value="item.value"
                        :multiple="true"
                        @change="$emit('change', { newValue: $event, qID: item.questionID })"
                    ></laid-out-select-input>
                    <laid-out-check-boxes
                        v-if="item.config.inputType == 'c2'"
                        :key="`intervention-item${index}-${key}`"
                        :options="item.config.options"
                        :value="Array.isArray(item.value) ? item.value : [item.value]"
                        @change="$emit('change', { newValue: [$event], qID: item.questionID })"
                    ></laid-out-check-boxes>
                    <number-select-input 
                        v-if="item.config.inputType == 'n'"
                        :key="`intervention-item${index}-${key}`"
                        :data="item"
                        @change="$emit('change', { newValue: $event, qID: item.questionID })"
                    ></number-select-input>
                    <textfield-landscape
                        v-if="item.config.inputType == 't'"
                        :key="`intervention-item${index}-${key}`"
                        :data="item"
                        @change="$emit('change', { newValue: $event, qID: item.questionID })"
                    ></textfield-landscape>
                    <v-textarea
                        v-if="item.config.inputType == 'ta'"
                        :key="`intervention-item${index}-${key}`"
                        :label="item.config.question"
                        :value="item.value"
                        @change="$emit('change', { newValue: $event, qID: item.questionID })"
                        no-resize
                        outline
                        hide-details
                        height="88px"
                        row-height="20px"
                    ></v-textarea>
                    <horizontal-check-boxes
                        v-if="item.config.inputType == 'c'"
                        :key="`intervention-item${index}-${key}`"
                        :options="item.config.options"
                        :value="item.value"
                        @change="$emit('change', { newValue: $event, qID: item.questionID })"
                    ></horizontal-check-boxes>         
                </template>
                <div class="clear"></div>             
            </div>
        </template>
    </div>
</template>

<script>
import LaidOutSelectInput from '@/components/LaidOutSelectInput.vue'
import LaidOutCheckBoxes from '@/components/LaidOutCheckBoxes.vue'
import NumberSelectInput from '@/components/NumberSelectInput.vue'
import TextfieldLandscape from '@/components/TextfieldLandscape.vue'
import HorizontalCheckBoxes from '@/components/HorizontalCheckBoxes.vue'

import forms from '@/utils/forms'

export default {
    name: 'InterventionRecordsForm',

    props: {
        data: {
            required: true,
            type: Array
        },
        hiddenParams: {
            required: true,
            type: Object
        }
    },
    components: {
        LaidOutSelectInput,
        LaidOutCheckBoxes,
        NumberSelectInput,
        TextfieldLandscape,
        HorizontalCheckBoxes
    },
    methods: {
        getIfFieldFocusClass(items) {
            if (this.hiddenParams) {
                let isSelect = false
                items.map(item => {
                    if (item.config) {
                        if (item.config.field == this.hiddenParams.focus) {
                            isSelect = true
                        }
                    }
                    
                })

                if (isSelect) {
                    setTimeout(() => {
                        this.scrollToFocus()
                    }, 0)
                }

                return isSelect ? 'focus': ''
            } else {
                return ''
            }
        },
        scrollToFocus () {
            const focusdEls = document.querySelectorAll('.input-wrapper.focus')
            const focusd = [...focusdEls].filter(el => el.offsetParent !== null)[0]
            const container = document.querySelectorAll('.v-window')[0]
            if (typeof(focusd) != 'undefined') {
                container.scrollTop = focusd.offsetTop
            }
        }
    }
}
</script>
<style lang="scss">

</style>